module.exports = __webpack_public_path__ + "static/img/19.fa90120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/19.png
// module id = /E12
// module chunks = 0